<template>
	<div class="advert-manage-container">
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.triggerSource" placeholder="请输入项目名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择经营类型" clearable style="width: 100%">
						<el-option label="创新租赁" value="创新租赁" />
						<el-option label="委托租售" value="委托租售" />
						<el-option label="增值服务" value="增值服务" />
						<el-option label="房产经纪" value="房产经纪" />
						<el-option label="其他" value="其他" />
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.assetCategory" placeholder="请选择经营状态" clearable style="width: 100%">
						<el-option label="筹备中" value="筹备中" />
						<el-option label="进行中" value="进行中" />
						<el-option label="已结项" value="已结项" />
						<el-option label="已终止" value="已终止" />
					</el-select>
				</el-col>
			</template>
		</QueryCard>
		<!-- 表格 -->
		<BaseTable
			:actions="{
				operation: true,
			}"
			:selection="false"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange">
			<template slot="toolbar">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增项目</el-button>
			</template>
			<template #businessType="{ row }">
				<el-tag :type="getBusinessTypeTag(row.businessType)" size="small">
					{{ row.businessType }}
				</el-tag>
			</template>
			<template #assets="{ row }">
				<el-tag
					v-for="(tag, i) in row.assets"
					:key="i"
					type="info"
					style="margin-right: 6px; margin-top: 5px"
					size="mini">
					{{ tag }}
				</el-tag>
			</template>
			<template #progress="{ row }">
				<el-progress :percentage="row.progress"></el-progress>
			</template>
			<template #status="{ row }">
				<el-tag :type="getStatusTag(row.status)" size="small">
					{{ row.status }}
				</el-tag>
			</template>
			<template #operation="{ row }">
				<el-button type="text" @click="handleDetail(row)">详情</el-button>
				<el-button type="text" @click="handleCompletion(row)" v-if="row.status === '进行中'">结项</el-button>
				<el-popconfirm title="请确认是否审核通过此条项目？" icon="el-icon-info" v-if="row.status === '筹备中'">
					<el-button type="text" slot="reference" @click="handleAudit(row)" style="margin-left: 12px">审核</el-button>
				</el-popconfirm>
				<el-popconfirm title="是否删除？" icon="el-icon-info" icon-color="red" v-if="row.status === '筹备中'">
					<el-button slot="reference" type="text" style="color: #f56c6c; margin-left: 12px" @click="handleDelete(row)">
						删除
					</el-button>
				</el-popconfirm>
				<el-button
					slot="reference"
					type="text"
					style="color: #f56c6c"
					@click="handleStop(row)"
					v-if="row.status === '进行中'">
					中止
				</el-button>
			</template>
		</BaseTable>

		<ProjectManagementAddDialog :dialogVisible.sync="dialogVisible" />
		<ProjectStatusDialog :dialogVisible.sync="dialogProjectStatusVisible" :projectStatus="projectStatus" />
		<ProjectManagementDetailDrawer :dialogVisible.sync="drawerVisible" :data="currentRow" />
	</div>
</template>

<script>
	import ProjectManagementAddDialog from '@/components/operation/projectManagementAddDialog.vue';
	import ProjectStatusDialog from '@/components/operation/projectStatusDialog.vue';
	import ProjectManagementDetailDrawer from '@/components/operation/projectManagementDetailDrawer.vue';
	export default {
		components: {
			ProjectManagementAddDialog,
			ProjectStatusDialog,
			ProjectManagementDetailDrawer,
		},
		data() {
			return {
				total: 4,
				query: {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				},
				tableData: [
					{
						projectCode: 'XM-20260421-0001',
						projectName: 'A栋广告位创新租赁',
						businessType: '创新租赁',
						community: '南京软件谷项目',
						assets: ['A栋1层广告位', 'A栋2层广告位'],
						period: '2026-01-01 至 2026-12-31',
						expectedIncome: 120000,
						actualIncome: 85000,
						progress: 31,
						status: '进行中',
					},
					{
						projectCode: 'XM-20260420-0002',
						projectName: 'B栋委托租售项目',
						businessType: '委托租售',
						community: '南京软件谷项目',
						assets: ['B栋301室 ', ' B栋302室'],
						period: '2026-03-01 至 2026-08-31',
						expectedIncome: 50000,
						actualIncome: 30000,
						progress: 29,
						status: '进行中',
					},
					{
						projectCode: 'XM-20260315-0003',
						projectName: '停车场增值服务',
						businessType: '增值服务',
						community: '南京软件谷项目',
						assets: ['地下停车场A区'],
						period: '2026-01-01 至 2026-06-30',
						expectedIncome: 30000,
						actualIncome: 30000,
						progress: 62,
						status: '已结项',
					},
					{
						projectCode: 'XM-20260422-0004',
						projectName: 'C栋房产经纪项目',
						businessType: '房产经纪',
						community: '南京软件谷项目',
						assets: ['C栋101室'],
						period: '2026-05-01 至 2026-10-31',
						expectedIncome: 80000,
						actualIncome: 0,
						progress: 0,
						status: '筹备中',
					},
				],
				columns: [
					{ label: '项目编号', prop: 'projectCode' },
					{ label: '项目名称', prop: 'projectName' },
					{ label: '经营类型', prop: 'businessType', slot: 'businessType' },
					{ label: '所属小区', prop: 'community' },
					{ label: '关联资产', prop: 'assets', slot: 'assets' },
					{ label: '项目周期', prop: 'period' },
					{ label: '预计收入', prop: 'expectedIncome' },
					{ label: '实际收入', prop: 'actualIncome' },
					{ label: '完成进度', prop: 'progress', slot: 'progress' },
					{ label: '经营状态', prop: 'status', slot: 'status' },
				],
				loading: false,
				currentRow: {},
				dialogVisible: false,
				drawerVisible: false,
				dialogProjectStatusVisible: false,
				projectStatus: '1',
			};
		},
		methods: {
			getBusinessTypeTag(type) {
				const map = {
					创新租赁: 'primary',
					委托租售: 'success',
					增值服务: 'warning',
					房产经纪: 'info',
				};
				return map[type] || 'default';
			},
			getStatusTag(status) {
				const map = {
					进行中: 'primary',
					已结项: 'success',
					筹备中: 'info',
					异常: 'danger',
				};
				return map[status] || 'default';
			},
			getList() {},
			pageChange(page) {
				this.query.pageNum = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.pageSize = size;
				this.getList();
			},
			handleSearch() {
				this.query.pageNum = 1;
				this.getList();
			},
			handleReset() {
				this.query = {
					triggerSource: '',
					pageNum: 1,
					pageSize: 10,
				};
				this.getList();
			},
			handleAdd() {
				this.dialogVisible = true;
			},
			handleDetail(row) {
				this.currentRow = row;
				this.drawerVisible = true;
			},
			handleAudit(row) {
				this.currentRow = row;
			},
			handleDelete(row) {
				this.currentRow = row;
			},
			handleCompletion(row) {
				this.currentRow = row;
				this.projectStatus = '1';
				this.dialogProjectStatusVisible = true;
			},
			handleStop(row) {
				this.currentRow = row;
				this.projectStatus = '2';
				this.dialogProjectStatusVisible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}
</style>
